// hooks/site/context.js
import { createContext, useContext, useReducer } from 'react';
import { siteReducer, initialState } from './reducer';

const SiteContext = createContext();

export const SiteProvider = ({ children }) => {
    const [state, dispatch] = useReducer(siteReducer, initialState);

    return <SiteContext.Provider value={[state, dispatch]}>{children}</SiteContext.Provider>;
};

export const useSiteContext = () => {
    const context = useContext(SiteContext);
    if (!context) {
        throw new Error('useSiteContext must be used within a SiteProvider');
    }
    return context;
};
